
import styled from 'styled-components'
import { device } from '../responsive'

export const Container = styled.div`
    
`
export const Wrapper = styled.div`
    max-width: 1200px;
    margin: auto;
    padding: 3rem 3rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;    

    @media screen and ${device.mobile} {
        padding: 1rem;
    }
`

export const IconBox = styled.div`
    display: flex;   
    margin-bottom: 1rem;

    @media screen and ${device.mobile} {
        margin: 1.5rem 0rem 0.6rem;
    }
`

export const Icon = styled.div`
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    
    &:hover {
        transform: scale(1.2);
        color: teal;
    }
`

export const IconLink = styled.a`
    color: #000;
    transition: all 0.3s ease-in-out;
    font-size: 1.8rem;

    &:hover {
        color: teal;
    }
`
export const Rights = styled.p`
    font-size: 0.8rem;
    margin-top: 0rem;
    
`